export default __webpack_public_path__ + "static/media/shopOwner.693bac4e.jpg";